//noScroll
class ContactDisplay {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const telBox = document.querySelector("#pg-338-0")
    const contactText01 = document.querySelector("#panel-338-1-0-0")
    const contactText02 = document.querySelector("#panel-338-1-0-1")


    console.log(telBox);

    const contactForm = document.querySelector("#mw_wp_form_mw-wp-form-340")

    // contactForm.classList.contains("mw_wp_form_confirm")

    console.log(contactForm.classList.contains("mw_wp_form_confirm"));

    if(contactForm.classList.contains("mw_wp_form_confirm") || contactForm.classList.contains("mw_wp_form_complete")){
      telBox.style.display = "none"
      contactText01.style.display = "none"
      contactText02.style.display = "none"
    }
  }
}